import { createRouter, createWebHistory } from 'vue-router'
import HelloWorld from './components/HelloWorld.vue'
import Post from './components/Post.vue'

const routes = [
  {
    path: '/',
    name: 'HelloWorld',
    component: HelloWorld,
    meta:{
      keepAlive:true
    }
  },
  {
    path: '/post',
    name: 'Post',
    component: Post,
    meta:{
      keepAlive:true
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router